<template>
  <div>
    <a-tree
      v-model="checkedKeys"
      :tree-data="treeData"
      :checkable="checkable"
      :expanded-keys="expandKeys"
      :show-line="showLine"
      @check="handleCheck"
      @select="handleSelect"
      @expand="handleExpand"
    />
  </div>
</template>

<script>
export default {
  name: 'Treex',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    checkable: {
      type: Boolean,
      default: true
    },
    showLine: {
      type: Boolean,
      default: false
    },
    rootId: {
      type: [String, Number],
      default: null
    },
    expandAll: {
      type: Boolean,
      default: false
    },
    keyName: {
      type: String,
      default: 'id'
    },
    titleName: {
      type: String,
      default: 'name'
    }
  },
  data () {
    return {
      treeData: [],
      checkedKeys: [],
      expandKeys: []
    }
  },
  watch: {
    data () {
      this.init()
    },
    value () {
      this.autoCheckAndExpand()
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.treeData = this.array2tree(JSON.parse(JSON.stringify(this.data)), this.rootId)
      console.log('this.treeData', this.treeData)
      this.autoCheckAndExpand()
    },
    autoCheckAndExpand () {
      const leaves = []
      this.getLeafIds(this.treeData, leaves)
      this.checkedKeys = this.value.filter(_ => leaves.indexOf(_) > -1)

      if (this.expandAll) {
        const nodes = []
        this.getNodeIds(this.treeData, nodes)
        this.expandKeys = nodes
      }
    },
    array2tree (array, rootId) {
      const result = []
      console.log('array', array)
      for (let i = array.length - 1; i >= 0; i--) {
        const a = array[i]
        if (a && a.parentId === rootId) {
          result.unshift(a)
          array.splice(i, 1)
          result[0].key = result[0][this.keyName]
          result[0].title = result[0][this.titleName]
          result[0].children = this.array2tree(array, result[0][this.keyName])
        }
      }

      return result
    },
    getLeafIds (tree, result) {
      for (let i = 0; i < tree.length; i++) {
        const { children } = tree[i]
        if (!children || children.length === 0) {
          result.push(tree[i][this.keyName])
        } else {
          this.getLeafIds(children, result)
        }
      }
    },
    getNodeIds (tree, result) {
      for (let i = 0; i < tree.length; i++) {
        const { children } = tree[i]
        if (children && children.length > 0) {
          result.push(tree[i][this.keyName])
          this.getNodeIds(children, result)
        }
      }
    },
    handleCheck (checkedKeys) {
      const value = []

      for (let i = 0; i < checkedKeys.length; i++) {
        let key = `${checkedKeys[i]}`

        if (value.indexOf(key) === -1) {
          value.unshift(key)
        }
        while (key.length > 2) {
          key = key.substring(0, key.length - 2)
          if (value.indexOf(key) === -1) {
            value.unshift(key)
          }
        }
      }

      this.$emit('input', value)
      this.$emit('check', value)
    },
    handleSelect (selectedKeys, info) {
      this.$emit('select', selectedKeys, info)
    },
    handleExpand (expandedKeys) {
      this.expandKeys = expandedKeys
    }
  }
}
</script>

<style scoped>

</style>
